// Until IE support is required, exporting the global fetch is sufficient
module.exports = fetch;
